var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "flex f-between f-center blinki-header fixed-top flex-md-nowrap",
      class: { "marque-header": _vm.marque },
    },
    [
      _c("div", { staticClass: "mt-3 flex f-center enviemoment-container" }, [
        _c("div", { staticClass: "flex f-between full-width" }, [
          _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 enviemoment-title",
            },
            [
              _c(
                "h1",
                {
                  staticClass: "title-sandwich flex pointer",
                  on: {
                    click: function ($event) {
                      return _vm.fullScreen()
                    },
                  },
                },
                [
                  _c("span", {
                    staticClass: "icon-sandiwch-bar title-bar mr-3 not-enable",
                    attrs: { id: "marque-popover" },
                  }),
                  _vm._v(" "),
                  _vm.marque
                    ? _c(
                        "b-popover",
                        {
                          attrs: {
                            target: "marque-popover",
                            triggers: "focus hover  ",
                            placement: "bottom",
                          },
                        },
                        [
                          _c(
                            "b-list-group",
                            { staticClass: "dropdown-marque" },
                            [
                              _c(
                                "b-list-group-item",
                                {
                                  staticClass:
                                    "d-flex justify-content-between align-items-center pointer",
                                  attrs: { button: "" },
                                },
                                [
                                  _c(
                                    "nuxt-link",
                                    {
                                      staticClass:
                                        "text-capitalize text-decoration-none",
                                      attrs: { to: "/" },
                                    },
                                    [
                                      _c(
                                        "p",
                                        { staticClass: "m-0 mr-2 big-font" },
                                        [_vm._v("Accueil")]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-list-group-item",
                                {
                                  staticClass:
                                    "d-flex justify-content-between align-items-center pointer",
                                  attrs: { button: "" },
                                },
                                [
                                  _c(
                                    "nuxt-link",
                                    {
                                      staticClass:
                                        "text-capitalize text-decoration-none",
                                      attrs: { to: "/livraisons" },
                                    },
                                    [
                                      _c(
                                        "p",
                                        { staticClass: "m-0 mr-2 big-font" },
                                        [_vm._v("Gestion des livraisons")]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-list-group-item",
                                {
                                  staticClass:
                                    "d-flex justify-content-between align-items-center pointer",
                                  attrs: { button: "" },
                                },
                                [
                                  _c(
                                    "nuxt-link",
                                    {
                                      staticClass:
                                        "text-capitalize text-decoration-none",
                                      attrs: { to: "/commandes" },
                                    },
                                    [
                                      _c(
                                        "p",
                                        { staticClass: "m-0 mr-2 big-font" },
                                        [_vm._v("Gestion des commandes")]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-list-group-item",
                                {
                                  staticClass:
                                    "d-flex justify-content-between align-items-center pointer",
                                  attrs: { button: "" },
                                },
                                [
                                  _c(
                                    "nuxt-link",
                                    {
                                      staticClass:
                                        "text-capitalize text-decoration-none",
                                      attrs: { to: "/retours" },
                                    },
                                    [
                                      _c(
                                        "p",
                                        { staticClass: "m-0 mr-2 big-font" },
                                        [_vm._v("Gestion des retours")]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-list-group-item",
                                {
                                  staticClass:
                                    "d-flex justify-content-between align-items-center pointer",
                                  attrs: { button: "" },
                                },
                                [
                                  _c(
                                    "nuxt-link",
                                    {
                                      staticClass:
                                        "text-capitalize text-decoration-none",
                                      attrs: { to: "/messagerie" },
                                    },
                                    [
                                      _c(
                                        "p",
                                        { staticClass: "m-0 mr-2 big-font" },
                                        [_vm._v("Messagerie")]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.title)),
                  ]),
                ],
                1
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex" },
        [
          _c(
            "b-dropdown",
            {
              staticStyle: { "max-height": "20px" },
              scopedSlots: _vm._u([
                {
                  key: "button-content",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "flex f-center",
                          staticStyle: { "max-height": "10px" },
                        },
                        [
                          _c("div", { staticClass: "pr-2" }, [
                            _c("div", { staticClass: "person-name" }, [
                              _vm._v(
                                _vm._s(_vm._f("if_null")(_vm.user.fullname))
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "perspne-role" }, [
                              _vm._v(_vm._s(_vm._f("if_null")(_vm.user.role))),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "person pl-2",
                              staticStyle: { "max-height": "30px" },
                            },
                            [
                              _c("span", {
                                staticClass: "icon-round-account",
                                staticStyle: {
                                  "max-height": "30px",
                                  "font-size": "30px",
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _vm._v(" "),
              _c(
                "b-dropdown-item",
                [
                  _c(
                    "a",
                    {
                      directives: [
                        {
                          name: "b-modal",
                          rawName: "v-b-modal.profil-update",
                          modifiers: { "profil-update": true },
                        },
                      ],
                      staticClass: "nav-link",
                      on: {
                        click: function ($event) {
                          return _vm.getProfilInfos()
                        },
                      },
                    },
                    [_vm._v("Profil")]
                  ),
                  _vm._v(" "),
                  _c("profil-update"),
                ],
                1
              ),
              _vm._v(" "),
              _vm.marque
                ? _c(
                    "b-dropdown-item",
                    [
                      _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "b-modal",
                              rawName: "v-b-modal.marque-update",
                              modifiers: { "marque-update": true },
                            },
                          ],
                          staticClass: "nav-link",
                          on: { click: _vm.setMarque },
                        },
                        [_vm._v("Ma Marque")]
                      ),
                      _vm._v(" "),
                      _c("updateMarque", {
                        attrs: { marque: _vm.currentMarque },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("b-dropdown-item", [
                _c(
                  "a",
                  {
                    staticClass: "nav-link",
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        return _vm.logout()
                      },
                    },
                  },
                  [_vm._v("Déconnexion")]
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }